import React, { FC } from 'react';
import { formatDate } from '@fiverr-private/futile';
import { dateTimeFormat, DATETIME_ELEMENT_STYLES } from '@fiverr-private/localization';
import { getContext, I18n } from '@fiverr-private/fiverr_context';

import TimeToRead from '../TimeToRead';
import CalendarSVG from './assets/calendar.svg';

import './index.scss';

interface LabelsProps {
  publishedDate: string;
  dateModified?: string;
  timeToRead?: number;
  author?: {
    authorName: string;
  };
}

const Labels: FC<LabelsProps> = ({ publishedDate, dateModified, timeToRead, author = {} as any }) => {
  const { locale } = getContext();
  const { authorName } = author;
  const displayedDate = dateModified || publishedDate;

  return (
    <div className="labels">
      {authorName && (
        <div className="author-name">
          <I18n k="fiverr_guides.by" params={{ authorName }} />
        </div>
      )}
      <div>
        <img src={CalendarSVG} />
        {dateTimeFormat(new Date(displayedDate), {
          fallbackValue: formatDate(new Date(displayedDate), {
            locale,
            month: 'long',
          }),
          year: DATETIME_ELEMENT_STYLES.NUMERIC,
          month: DATETIME_ELEMENT_STYLES.LONG,
          day: DATETIME_ELEMENT_STYLES.NUMERIC,
        })}
      </div>
      {!!timeToRead && timeToRead > 0 && (
        <div>
          <TimeToRead timeToRead={timeToRead} />
        </div>
      )}
    </div>
  );
};

export default Labels;
